//NOTE: files with "b64_" prefix are pre-encoded to base64 in order to save computation time, they should not be changed
export default [
    {
        "name": "css/img/offline.jpg",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_offline.jpg").default
    },
	{
        "name": "css/img/technical-break.png",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_technical-break.png").default
    },
    {
        "name": "css/img/logo-192.png",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_logo-192.png").default
    },
    {
        "name": "css/img/logo-512.png",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_logo-512.png").default
    },
    {
        "name": "css/img/logo.png",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_logo.png").default
    },
    {
        "name": "css/img/flags.png",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_flags.png").default
    },
	{
        "name": "css/img/img-placeholder.jpg",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_img-placeholder.jpg").default
    },
    {
        "name": "css/img/multicolor.png",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_multicolor.png").default
    },
    {
        "name": "css/img/star.svg",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_star.svg").default
    },
    {
        "name": "css/img/star-grey.svg",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_star-grey.svg").default
    },
    {
        "name": "css/img/star-o.svg",
        "encoded": true,
        "text": require("./staticFiles/css/img/b64_star-o.svg").default
    },
	{
        "name": "css/img/fontawesome-icons.svg",
        "encoded": false,
        "text": require("./staticFiles/css/img/b64_fontawesome-icons.svg").default
    },
    {
        "name": "__settings.liquid",
        "encoded": false,
        "text": require("./staticFiles/__settings.liquid").default
    },

    {
        "name": "__loginconsents.liquid",
        "encoded": false,
        "text": require("./staticFiles/__loginconsents.liquid").default
    },
    {
        "name": "scss/components/_collection-points.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/components/_collection-points.scss.js").default
    },
    {
        "name": "scss/components/_country-flags.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/components/_country-flags.scss.js").default
    },
    {
        "name": "scss/components/_offline.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/components/_offline.scss.js").default
    },
    {
        "name": "scss/components/_pagination.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/components/_pagination.scss.js").default
    },
    {
        "name": "scss/globals/_global-variables.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/globals/_global-variables.scss.js").default
    },
    {
        "name": "scss/globals/_globals-m.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/globals/_globals-m.scss.js").default
    },
    {
        "name": "scss/globals/_globals1.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/globals/_globals1.scss.js").default
    },
    {
        "name": "scss/globals/_globals2.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/globals/_globals2.scss.js").default
    },
    {
        "name": "scss/globals/_mixins.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/globals/_mixins.scss.js").default
    },
    {
        "name": "scss/partials/_home.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/partials/_home.scss.js").default
    },
    {
        "name": "scss/collection-points.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/collection-points.scss").default
    },
    {
        "name": "scss/desktop1.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/desktop1.scss").default
    },
    {
        "name": "scss/desktop2.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/desktop2.scss").default
    },
    {
        "name": "scss/mobile.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/mobile.scss").default
    },
    {
        "name": "scss/offline.scss",
        "encoded": false,
        "text": require("./staticFiles/scss/offline.scss").default
    },
    {
        "name": "js/collection-points.js",
        "encoded": false,
        "text": require("./staticFiles/js/collection-points").default
    },
    {
        "name": "js/fb-login.js",
        "encoded": false,
        "text": require("./staticFiles/js/fb-login").default
    },
    {
        "name": "js/google-login.js",
        "encoded": false,
        "text": require("./staticFiles/js/google-login").default
    },
    {
        "name": "js/init-ui1.js",
        "encoded": false,
        "text": require("./staticFiles/js/init-ui1").default
    },
    {
        "name": "js/init-ui1.min.js",
        "encoded": false,
        "text": require("./staticFiles/js/init-ui1.min.js").default
    },
    {
        "name": "js/init-ui2.js",
        "encoded": false,
        "text": require("./staticFiles/js/init-ui2").default
    },
    {
        "name": "js/init-ui2.min.js",
        "encoded": false,
        "text": require("./staticFiles/js/init-ui2.min.js").default
    },
    {
        "name": "js/js.js",
        "encoded": false,
        "text": require("./staticFiles/js/js").default
    },
    {
        "name": "js/js.min.js",
        "encoded": false,
        "text": require("./staticFiles/js/js.min.js").default
    },
    {
        "name": "js/manifest.json",
        "encoded": false,
        "text": require("./staticFiles/js/manifest.json").default
    },
    {
        "name": "js/sw.js",
        "encoded": false,
        "text": require("./staticFiles/js/sw").default
    },
    {
        "name": "edrone/head.html",
        "encoded": false,
        "text": require("./staticFiles/edrone/head.html").default
    },
    {
        "name": "edrone/order.html",
        "encoded": false,
        "text": require("./staticFiles/edrone/order.html").default
    },
    {
        "name": "edrone/product-presentation.html",
        "encoded": false,
        "text": require("./staticFiles/edrone/product-presentation.html").default
    },
    {
        "name": "css/collection-points.css",
        "encoded": false,
        "text": require("./staticFiles/css/collection-points.css").default
    },
    {
        "name": "css/desktop1.css",
        "encoded": false,
        "text": require("./staticFiles/css/desktop1.css").default
    },
    {
        "name": "css/desktop2.css",
        "encoded": false,
        "text": require("./staticFiles/css/desktop2.css").default
    },
    {
        "name": "css/mobile.css",
        "encoded": false,
        "text": require("./staticFiles/css/mobile.css").default
    },
    {
        "name": "css/offline.css",
        "encoded": false,
        "text": require("./staticFiles/css/offline.css").default
    }
]